import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item6/subitm1.jpg";
import img2 from "../assets/images/item6/subitm2.jpg";
import img3 from "../assets/images/item6/subitm3.jpg";
import img4 from "../assets/images/item6/subitm4.jpg";
import img5 from "../assets/images/item6/subitm5.jpg";
import img6 from "../assets/images/item6/subitm6.jpg";


const rowsData = [
  {
    id: 1,
    title: "All Types Of Seals",
    text: "High-quality seals to prevent leaks and maintain pressure in machinery.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Industrial seals are used to prevent fluid or air leakage in machines and equipment. They help maintain pressure and improve system efficiency. Made from durable rubber, silicone, or polymer materials.`
  },
  {
    id: 2,
    title: "Gear & Sprocket",
    text: "Durable gears and sprockets for smooth power transmission.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Gears and sprockets transfer mechanical power efficiently in industrial machines. They are designed for high strength and long-lasting performance. Available in various sizes and materials to suit different applications.`
  },
  {
    id: 3,
    title: "Industrial Belt",
    text: "Strong industrial belts for reliable power and motion transfer.",
    img: img3,
    gradient: "gradient3",
    stars: 4,
    description: `Industrial belts transmit power between rotating shafts in machinery. Made from high-strength rubber or synthetic materials. Provide smooth, slip-free operation even under heavy loads.
`
  },
  {
    id: 4,
    title: "Shafts & Rods",
    text: "Precision-engineered shafts and rods for mechanical power transmission.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `FiShafts and rods are essential for transferring rotational or linear motion. Manufactured from high-grade steel for strength and durability. Available in various diameters and lengths to fit different machines.
`
  },
  {
    id: 5,
    title: "Pulleys",
    text: "High-strength pulleys for efficient belt-driven systems.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Pulleys are used to guide belts and transfer motion in mechanical systems. Made from durable materials like steel or cast iron. Reduce friction and ensure smooth power transmission.
`
  },
  {
    id: 6,
    title: "Couplings",
    text: "Reliable couplings to connect rotating shafts and transmit power.",
    img: img6,
    gradient: "gradient5",
    stars: 5,
    description: `Couplings join two shafts to transmit torque while compensating for misalignment. Designed to reduce vibration and protect connected equipment. Available in flexible, rigid, and fluid coupling types.
`
  }
];

function Z6() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z6;